var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useDispatch, useSelector } from 'react-redux';
import { store } from './store';
const useAppDispatch = () => (_react_refresh_temp_1(), useDispatch());
_react_refresh_temp_1(useAppDispatch, "jI3HA1r1Cumjdbu14H7G+TUj798=", false, () => [useDispatch]);
const useAppSelector = useSelector;
export { store, useAppDispatch, useAppSelector };
